import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.urnResource('stonecode_file_service')
@doc.path('/stonecode_file_services/{?id}')
@doc.timestampable
abstract class AbstractStonecodeFileServiceModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		serviceUrn: Urn;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare serviceUrn: Urn;
}

interface AbstractStonecodeFileServiceModel extends Timestampable {}

export default AbstractStonecodeFileServiceModel;
